//@flow
import React from 'react';
import {useHistory} from 'react-router-dom';
import {
  makeStyles,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Hidden,
} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import PremiumFeatureBadge from '../../../elements/PremiumFeatureBadge/PremiumFeatureBadge';
import {useIsFeatureInTier} from '../../../utils/component';
import {colors} from '../../../assets/styles/colors';
import {useState} from 'react';
import ProductBatchLoadCreate from './ProductBatchLoadCreate';
import Tutorials from './Tutorials';
import ProductBatchLoadUpdate from './ProductBatchLoadUpdate';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    background: '#F8F9FB',
    padding: '1rem',
    marginBottom: '64px',
    gap: '1rem',
    maxWidth: 1200,

    [theme.breakpoints.up('md')]: {
      marginBottom: '0',
    },
  },
  header: {
    maxWidth: 1200,
    background: '#f8f9fb',
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'black',
  },
  backButton: {
    background: 'white',
    padding: '4px',
    margin: '0 16px 0 0',
    boxShadow:
      '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
  },
  sectionDescription: {
    marginTop: theme.spacing(2),
    color: colors.grey700,
    fontSize: '0.875rem',
  },
  tabButton: {
    fontSize: '.75rem',
    fontWeight: 600,
    color: colors.grey700,
    textTransform: 'none',

    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
    },
  },
}));

const uploadTutorials = [
  {
    name: 'Producto',
    thumbnail: 'https://img.youtube.com/vi/EwnSdzF6pPE/sddefault.jpg',
    videoId: 'EwnSdzF6pPE',
  },
  {
    name: 'Variantes',
    thumbnail: 'https://img.youtube.com/vi/ZHgo8qm77Kc/sddefault.jpg',
    videoId: 'ZHgo8qm77Kc',
  },
  {
    name: 'Precios al por mayor',
    thumbnail: 'https://img.youtube.com/vi/yveB_ddReCM/sddefault.jpg',
    videoId: 'yveB_ddReCM',
  },
];

const editTutorials = [
  {
    name: 'Editar tus productos',
    thumbnail: 'https://img.youtube.com/vi/GL5J7xIHBr0/sddefault.jpg',
    videoId: 'GL5J7xIHBr0',
  },
];

export default function ProductBatchLoad() {
  const classes = useStyles();
  const hasMassiveProductUploadFeature = useIsFeatureInTier(
    'MASSIVE_PRODUCT_UPLOAD'
  );

  const [tabValue, setTabValue] = useState<'create' | 'edit' | 'tutorial'>(
    'create'
  );

  const history = useHistory();

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <Typography className={classes.title}>
          <IconButton
            className={classes.backButton}
            onClick={() => history.goBack()}
          >
            <ArrowBack />
          </IconButton>
          Creación/Edición de productos masivo
          {!hasMassiveProductUploadFeature && <PremiumFeatureBadge />}
        </Typography>
        <Typography className={classes.sectionDescription}>
          Sube o edita productos de forma masiva. Recuerda seguir las
          instrucciones al pie de la letra.
        </Typography>
      </header>

      <Hidden mdUp>
        <Tabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          aria-label="Editar o crear"
          className={classes.tabs}
          indicatorColor="primary"
        >
          <Tab
            className={classes.tabButton}
            value="create"
            label="Carga Masiva"
          />
          <Tab
            className={classes.tabButton}
            value="edit"
            label="Edición Masiva"
          />
        </Tabs>
      </Hidden>
      <Hidden smDown>
        <Tabs
          value={tabValue}
          onChange={(event, newValue) => setTabValue(newValue)}
          aria-label="Editar o crear"
          className={classes.tabs}
          variant="fullWidth"
          indicatorColor="primary"
        >
          <Tab
            className={classes.tabButton}
            value="create"
            label="Carga Masiva"
          />
          <Tab
            className={classes.tabButton}
            value="edit"
            label="Edición Masiva"
          />
        </Tabs>
      </Hidden>

      {tabValue === 'create' && (
        <>
          <ProductBatchLoadCreate />
          <Tutorials tutorialList={uploadTutorials} />
        </>
      )}
      {tabValue === 'edit' && (
        <>
          <ProductBatchLoadUpdate />
          <Tutorials tutorialList={editTutorials} />
        </>
      )}
    </div>
  );
}
